export default "/static/webpack/media/undraw_report.4583035d.svg";